const formatterCache = new Map();

const getLocaleCacheKey = (locale) => {
  if (Array.isArray(locale)) {
    return locale.join(',');
  }

  if (locale === undefined || locale === null || locale === '') {
    return 'default';
  }

  return String(locale);
};

const getOptionsCacheKey = (options = {}) => {
  const keys = Object.keys(options).sort();
  return keys.map((key) => `${key}:${String(options[key])}`).join('|');
};

const getFormatter = (locale, options = {}) => {
  const cacheKey = `${getLocaleCacheKey(locale)}__${getOptionsCacheKey(options)}`;
  const cachedFormatter = formatterCache.get(cacheKey);
  if (cachedFormatter) {
    return cachedFormatter;
  }

  const formatter = new Intl.DateTimeFormat(locale, options);
  formatterCache.set(cacheKey, formatter);
  return formatter;
};

export const toValidDate = (value) => {
  if (value === undefined || value === null || value === '') {
    return null;
  }

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const formatDateWithIntl = (value, locale, options) => {
  const date = toValidDate(value);
  if (!date) return '';

  try {
    return getFormatter(locale, options).format(date);
  } catch (error) {
    return '';
  }
};

export const formatLocalDate = (value, locale, options) => (
  formatDateWithIntl(value, locale, options)
);

export const formatLocalTime = (
  value,
  locale,
  options = { hour: '2-digit', minute: '2-digit' }
) => (
  formatDateWithIntl(value, locale, options)
);

export const formatLocalDateTime = (value, locale, options) => (
  formatDateWithIntl(value, locale, options)
);

export const getLocalDayKey = (value) => {
  const date = toValidDate(value);
  if (!date) return '';

  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
};
